import * as React from 'react';
import { ProjectsWrapper, SubsectionBulletWrapper, SubsectionTitle, SubsectionWrapper } from '../ProjectOverviewStyles';
import { language } from '../ProjectOverviewLanguage';
import { ProjectOverviewLayout } from '../ProjectOverviewLayout';
import { ProjectLayout } from './ProjectLayout';
import { generateBullets } from '../helpers/generateBullets';
import { ToolsLayout } from './ToolsLayout';

export type Props = {
	subsection;
};

export const SubsectionLayout = (props: Props) => {
	const render = () => {
		const allTools = Array.from(consolidateTools(props.subsection));
		const bulletJSX = !props.subsection.bullets ? null : <SubsectionBulletWrapper>{generateBullets(props.subsection.bullets)}</SubsectionBulletWrapper>;
		const returnValue = (
			<SubsectionWrapper>
				<SubsectionTitle>{props.subsection.title}</SubsectionTitle>
				<ToolsLayout tools={allTools} />
				{bulletJSX}
				<ProjectsWrapper>{generateProjects(props.subsection.projects)}</ProjectsWrapper>
			</SubsectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

export const generateProjects = (projects) => {
	const returnValue = projects.map((project: any, index: number) => {
		const outgoingProps = {
			project,
		};
		const innerReturnValue = <ProjectLayout {...outgoingProps} />;
		return innerReturnValue;
	});
	return returnValue;
};

export const consolidateTools = (subsection) => {
	const returnValue = new Set();
	subsection.projects.forEach((project) => {
		project.tools.forEach((tool) => {
			returnValue.add(tool);
		});
	});
	return returnValue;
};
